import { render } from "./PromoCarousel.vue?vue&type=template&id=7e23a81c&scoped=true"
import script from "./PromoCarousel.vue?vue&type=script&lang=js"
export * from "./PromoCarousel.vue?vue&type=script&lang=js"

import "./PromoCarousel.vue?vue&type=style&index=0&id=7e23a81c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e23a81c"]])

export default __exports__